module.exports = __webpack_public_path__ + "static/media/b3.63187d4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xubin/b3.mp3
// module id = KLSS
// module chunks = 0